import { navigateTo } from "../../framework/router.ts";
import { authContext } from "../../context/AuthContext.ts";
import { DashboardUserManagement } from '../../components/skins/dashboard-user-management.ts';
import {ExpandableDirectory} from '../../components/directory-list.ts';

import { fetchAuditLogs } from "../../services/api.ts";

export default function UserManagementPage() {
  const container = document.createElement("div");
  container.classList.add("parent-container");
  container.innerHTML = new DashboardUserManagement().usermanagementskin();

  requestAnimationFrame(async () => {
    const logs = await fetchAuditLogs();
    const tbody = container.querySelector("#audit-body");

    tbody.innerHTML = logs.map(log => `
      <tr>
        <td class="text-left">${log.username}</td>
        <td class="text-left">${log.ip || "-"}</td>
        <td class="text-left">${new Date(log.timestamp).toLocaleString()}</td>
        <td class="text-left">${log.action} - ${log.details || ""}</td>
      </tr>
    `).join("");
  });

  return container;
}

